import React from 'react';
import ServerStatus from 'react-server-status';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';

import MdHelp from 'react-icons/lib/md/help-outline';

import css from '../styles/notfound';

class NotFound extends React.Component {

    static propTypes = {
        t: PropTypes.func.isRequired,
    };

    shouldComponentUpdate() {
        return false;
    }

    render() {
        const { t } = this.props;

        return (
            <ServerStatus status={404}>
                <div className={css.container}>
                    <div className={css.inner}>
                        <div className={css.iconWrapper}>
                            <MdHelp className={css.icon} />
                        </div>
                        <h2 className={css.title}>{t('title')}</h2>
                        <p className={css.text}>
                            {/* eslint-disable max-len */}
                            {t('text')}
                            <a href="info@omniekonomi.se"> {t('writeUs')}</a>
                            {/* eslint-enable max-len */}
                        </p>
                    </div>
                </div>
            </ServerStatus>
        );
    }
}

export default translate('notFound')(NotFound);



/** WEBPACK FOOTER **
 ** /src/shared/components/NotFound.js
 **/